import React from 'react';
import { withTranslation, Trans } from 'react-i18next';
import {Button, Modal, Header, Input, Message} from 'semantic-ui-react';

import Utils from 'utils/Utils.js'
import LoadInline from 'modules/loading/LoadInline.js';
import {colors, fontSizes, spacings, shadow, buttons} from 'style';
import styleDef from './style.js';

var style = {
    ...styleDef
};


const RewardBudgetModal = ({t, 
                            value, 
                            valid,
                            complete,
                            onChange, 
                            onClose, 
                            onSubmit}) => (
    <Modal open style={style.content} onClose={onClose} size='tiny'>
        <Modal.Header>{t('budget_modal_header')}</Modal.Header>
        <Modal.Content>
        <form onSubmit={onSubmit}>
            <Modal.Description>
                {!complete &&
                <div>
                    <div style={style.description}>{t('budget_modal_description')}</div>
                    <Input label='$' type='number' value={value} onChange={onChange} /> 
                    <br />
                </div>
                }
                <br />
                {complete &&
                    <Message positive>{t('budget_modal_complete_message')}</Message>
                }
                <br />
                {complete ? (
                    <Button type='button' style={style.button} onClick={onClose}>{t('OK')}</Button>
                ) : (
                    <Button type='submit' style={style.button} disabled={!valid}>{t('budget_modal_btn')}</Button>
                )}
            </Modal.Description>
        </form>
        </Modal.Content>
    </Modal>
);

export default withTranslation('rewards')(RewardBudgetModal);
